import React from "react";
import OTPInput from "otp-input-react";
import { SectionCardWrapper } from "../UI/SectionCardWrapper";
import FooterButton from "../../Pages/Footer";
import "./style.css";


const OtpInputCard = ({ title, resendOTP, otpValue, setOtpValue, ...rest }) => {
  return (
    <div
      className={"cls_mghunrey_1a588d"}
    >
      <div className={"cls_mghunrey_3c66cc"}>{title}</div>
      <OTPInput
        inputStyles={{
          border: "1px solid #cbcbcb",
          width: "50px",
          height: "50px",
        }}
        focusStyle={{
          border: "1px solid #cbcbcb",
        }}
        value={otpValue}
        onChange={setOtpValue}
        {...rest}
      />
    </div>
  );
};

function OtpCard({ validateOtp, otpValue, setOtpValue, mobileNo }) {
  mobileNo = mobileNo.toString()
  return (
    <SectionCardWrapper>
      <div>
        <OtpInputCard
          title= {`Please Enter the OTP recieved at your mobile number`}
          setOtpValue={setOtpValue}
          otpValue={otpValue}
          autoFocus
          OTPLength={4}
          otpType="number"
          disabled={false}
        />
        <div className={"cls_mghunrey_708fde"}>
          <FooterButton
            onNext={() => validateOtp({})}
            nextLabel="Verify"
            hideBack={true}
          />
        </div>
      </div>
    </SectionCardWrapper>
  );
}

export default OtpCard;
